import { render, staticRenderFns } from "./ReceivePrintDetails_Items.vue?vue&type=template&id=0b01ac6f&"
import script from "./ReceivePrintDetails_Items.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports